import React, {Component} from "react";
import {Accordion, Card, Modal, useAccordionButton} from "react-bootstrap";
import {toast} from "react-toastify";
import ApiConnect from "../../../Utils/ApiConnect";
import DeletePop from "../../Components/DeletePop";
import ProductAutoComplete from "../SalesPurchase/Components/ProductAutoComplete";

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey);
  return (
    <div className="row w-100" onClick={decoratedOnClick}>
      {children}
    </div>
  );
}

export default class RouteDetails extends Component {
  constructor() {
    super();
    this.state = {
      addProductModal: false,
      editProductModal: false,
      addRouteModal: false,
      editRouteModal: false,
      selectProduct: false,
      selectedRoute: false,
      deleteModal: false,
      routeData: false,
      formError: false,
      ProductList: false,
      btnDisable: false,
      myFData: [],
    };
  }
  componentDidMount = () => {
    this.fetchRouteData();
    this.fetchProductList();
  };
  fetchProductList = () => {
    ApiConnect.get(`/Module/SalesPurchase/Sales/SalesData`)
      .then((response) => {
        this.setState({
          ProductList: response.data.products.product,
        });
      })
      .catch((error) => console.log(error));
  };
  fetchRouteData = () => {
    ApiConnect.get("/Module/Accounts/AccountHead/RouteDetails").then(
      (response) => this.setState({ routeData: response.data })
    );
  };
  handleChange = (e) => {
    const newFdata = { ...this.state.myFData };
    if (e.target) {
      newFdata[e.target.name] = e.target.value;
    } else {
      newFdata["product"] = e.id;
    }
    this.setState({ myFData: newFdata });
  };
  handleAddproduct = (e) => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdatas = new FormData();
    Fdatas.append("route", this.state.selectedRoute);
    Fdatas.append("product", this.state.myFData.product);
    Fdatas.append("rate", this.state.myFData.rate);
    ApiConnect({
      method: "post",
      url: "/Module/Accounts/AccountHead/NewRouteProduct",
      data: Fdatas,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          this.setState({
            myFData: [],
            formError: false,
            selectedRoute: false,
            addProductModal: false,
          });
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.fetchRouteData();
        } else if (response.data.status) {
          toast.danger(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  };
  handleAddRoute = (e) => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdatas = new FormData();
    Fdatas.append("name", this.state.myFData.name);
    ApiConnect({
      method: "post",
      url: "/Module/Accounts/AccountHead/NewRoute",
      data: Fdatas,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          this.setState({
            myFData: [],
            formError: false,
            addRouteModal: false,
          });
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.fetchRouteData();
        } else if (response.data.status) {
          toast.danger(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  };
  SettriggerModal = () => {
    this.setState({ deleteModal: false });
  };
  render() {
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Route Details</strong>
                  <small className="subtitle">
                    Here you can edit,delete,view Routes Details.
                  </small>
                </h2>
              </div>
              <div className="right gap-items-2">
                <button
                  className="btn btn-primary  btn-float btn-round"
                  onClick={() => this.setState({ addRouteModal: true })}
                >
                  <span className="material-icons-outlined">add</span>
                </button>
              </div>
            </div>
          </header>
        </div>
        <div className="card">
          <div className="card-title">
            <h4>Route Details</h4>
          </div>
          <div className="card-body">
            <Accordion defaultActiveKey="0">
              {this.state.routeData &&
                this.state.routeData.map((routes, index) => (
                  <Card key={index}>
                    <Card.Header>
                      <CustomToggle eventKey={routes.id}>
                        <div className="d-flex flex-row">
                          <h4 className="col card-title">{routes.name}</h4>
                          <h4 className="col card-title d-flex flex-row">
                            <span className="material-icons text-success">
                              inventory
                            </span>
                            {routes.product.length} Products
                          </h4>
                        </div>
                      </CustomToggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey={routes.id}>
                      <Card.Body>
                        <button
                          className="right btn btn-primary btn-sm btn-round"
                          onClick={() =>
                            this.setState({
                              addProductModal: true,
                              selectedRoute: routes.id,
                            })
                          }
                        >
                          <span className="material-icons-outlined">add</span>
                        </button>
                        <table className="table table-responsive">
                          <thead>
                            <tr>
                              <th>Product Name</th>
                              <th>Rate</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {routes.product.map((prd, prdIndex) => (
                              <tr key={prdIndex}>
                                <td col="2">{prd.name}</td>
                                <td>{prd.rate}</td>
                                <td col="1">
                                  <button
                                    disabled={false}
                                    className="table-action btn btn-square btn-pure hover-danger"
                                    onClick={() => {
                                      this.setState({
                                        selectProduct: prd.id,
                                        selectedRoute: routes.id,
                                        deleteModal: true,
                                      });
                                    }}
                                  >
                                    <span className="material-icons-outlined">
                                      delete
                                    </span>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                ))}
            </Accordion>
            <DeletePop
              trigger={this.state.deleteModal}
              delUrl={`/Module/Accounts/AccountHead/DeleteRouteProduct?id=${this.state.selectProduct}&route=${this.state.selectedRoute}`}
              hideTrigger={this.SettriggerModal}
              fallAction={this.fetchRouteData}
            />
            <Modal
              show={this.state.addProductModal}
              className="modal-center"
              onHide={() => this.setState({ addProductModal: false })}
            >
              <Modal.Dialog>
                <Modal.Header>
                  <h5 className="modal-title">
                    New Product To Route{" "}
                    {this.state.selectedRoute.name &&
                      this.state.selectedRoute.name}
                  </h5>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => this.setState({ addProductModal: false })}
                  >
                    <span>×</span>
                  </button>
                </Modal.Header>
                <Modal.Body>
                  <p className="text-danger">{this.state.formError}</p>
                  <div className="row form-group">
                    <label className="form-label">Product Name</label>
                    {this.state.ProductList && (
                      <ProductAutoComplete
                        action={this.handleChange}
                        name="product"
                        // default={this.state.reset}
                        // defaultFallback={this.handleProductSelect}
                        placeHolder="Scan / search products by code / name"
                        items={this.state.ProductList}
                      />
                    )}
                  </div>
                  <div className="row form-group">
                    <label className="form-label">Rate</label>
                    <input
                      type="text"
                      name="rate"
                      className="form-control"
                      required
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    disabled={this.state.btnDisable}
                    className="btn btn-success"
                    onClick={(e) => this.handleAddproduct(e)}
                  >
                    Create
                  </button>
                </Modal.Footer>
              </Modal.Dialog>
            </Modal>
            <Modal
              show={this.state.addRouteModal}
              className="modal-center"
              onHide={() => this.setState({ addRouteModal: false })}
            >
              <Modal.Dialog>
                <Modal.Header>
                  <h5 className="modal-title">New Route</h5>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => this.setState({ addRouteModal: false })}
                  >
                    <span>×</span>
                  </button>
                </Modal.Header>
                <Modal.Body>
                  <p className="text-danger">{this.state.formError}</p>
                  <div className="row form-group">
                    <label className="form-label">Route Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      required
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    onClick={(e) => this.handleAddRoute(e)}
                    disabled={this.state.btnDisable}
                    className="btn btn-success"
                  >
                    Create
                  </button>
                </Modal.Footer>
              </Modal.Dialog>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}
